var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationalDataStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "24px,height:24px"
    },
    viewBox: "0 0 17.674 22.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data-base",
    transform: "translate(-6.75 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M22.656,3.375H8.517A1.767,1.767,0,0,0,6.75,5.142V24.584a1.767,1.767,0,0,0,1.767,1.767H22.656a1.767,1.767,0,0,0,1.767-1.767V5.142A1.767,1.767,0,0,0,22.656,3.375Zm0,1.767v5.3H8.517v-5.3ZM8.517,17.514v-5.3H22.656v5.3Zm0,7.07v-5.3H22.656v5.3Z",
    fill: "#545a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M13.017,8.759a.884.884,0,1,1-.884-.884A.884.884,0,0,1,13.017,8.759Z",
    transform: "translate(-0.965 -0.965)",
    fill: "#545a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M13.017,17.759a.884.884,0,1,1-.884-.884A.884.884,0,0,1,13.017,17.759Z",
    transform: "translate(-0.965 -2.896)",
    fill: "#545a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M13.017,26.759a.884.884,0,1,1-.884-.884A.884.884,0,0,1,13.017,26.759Z",
    transform: "translate(-0.965 -4.826)",
    fill: "#545a6d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationalDataStore);
export default __webpack_public_path__ + "static/media/operational-data-store.67e9565d4015f45a416a55c6ba84a7c4.svg";
export { ForwardRef as ReactComponent };